import React, { useState } from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { ReactComponent as ChevronDownIcon } from "feather-icons/dist/icons/chevron-down.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-7.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-8.svg";
import i18n from "helpers/i18n";

const Subheading = tw(SubheadingBase)`mb-4 text-center`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const Column = tw.div`flex flex-col items-center`;
const HeaderContent = tw.div``;

const FAQSContainer = tw.dl`mt-12 max-w-4xl relative`;
const FAQ = tw.div`cursor-pointer select-none mt-5 px-8 sm:px-10 py-5 sm:py-4 rounded-lg text-gray-800 hover:text-gray-900 bg-gray-200 hover:bg-gray-300 transition duration-300`;
const Question = tw.dt`flex justify-between items-center`;
const QuestionText = tw.span`text-lg lg:text-xl font-semibold`;
const QuestionToggleIcon = motion(styled.span`
  ${tw`ml-2 transition duration-300`}
  svg {
    ${tw`w-6 h-6`}
  }
`);
const Answer = motion(
  tw.dd`pointer-events-none text-sm sm:text-base leading-relaxed`
);

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-56 w-56 opacity-15 transform translate-x-2/3 -translate-y-12 text-teal-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-64 w-64 opacity-15 transform -translate-x-2/3 text-primary-500`}
`;

export default ({
  subheading = "FAQS",
  heading = "You have Questions ?",
  description = i18n.t(
    "Đây là câu trả lời cho những câu hỏi thường gặp nhất, nếu vẫn còn thắc mắc hãy liên hệ cho chúng tôi."
  ),
  faqs = [
    {
      question: i18n.t("Page có bị đánh dấu spam và bị khóa Page ?"),
      answer: i18n.t(
        "Có thể. Re:Marketing không bảo đảm tài khoản hoặc Page sẽ không bị hạn chế. Hãy chỉ gửi nội dung phù hợp tới người nhận có cơ sở liên hệ, theo dõi phản hồi và tuân thủ quy định của nền tảng."
      ),
    },
    {
      question: i18n.t("Tôi có thể sử dụng nhiều tài khoản Facebook một lúc ?"),
      answer: i18n.t(
        "Bạn có thể dùng các hồ sơ Chrome riêng cho từng tài khoản có quyền truy cập. Số Page, tin nhắn và IP được sử dụng vẫn phụ thuộc vào gói đã kích hoạt."
      ),
    },
    {
      question: i18n.t("Tôi cần chuẩn bị gì để sử dụng?"),
      answer: i18n.t(
        "Cài tiện ích trên Chrome, đăng nhập Facebook hoặc Pancake bằng tài khoản có quyền sử dụng, rồi liên hệ hỗ trợ để xác nhận gói và được cấp mã kích hoạt. Khi gửi, cần giữ trình duyệt mở và kết nối mạng. Sau sự cố, hãy kiểm tra trạng thái trước khi tiếp tục để tránh gửi trùng."
      ),
    },
    {
      question: i18n.t("Re:Marketing xử lý dữ liệu nào?"),
      answer: i18n.t(
        "Tệp khách hàng và tiến trình làm việc được lưu trong trình duyệt. Hệ thống dịch vụ xử lý thông tin liên hệ, mã kích hoạt, IP, hạn mức sử dụng và giao dịch; một số tác vụ kết nối cũng gửi dữ liệu tới máy chủ. Xem chi tiết trong chính sách dữ liệu."
      ),
    },
    {
      question: i18n.t("Tôi nhận mã dùng thử như thế nào?"),
      answer: i18n.t(
        "Liên hệ kênh hỗ trợ để xác nhận và được cấp mã dùng thử. Gói dùng thử hiện có 2.000 tin nhắn, 1 IP và thời hạn 1 tháng từ khi kích hoạt."
      ),
    },
    {
      question: i18n.t("Tôi mua gói và nhận mã như thế nào?"),
      answer: i18n.t(
        "Chọn gói trên trang tham khảo, rồi liên hệ hỗ trợ để xác nhận gói, giá, hạn mức, thời hạn và hướng dẫn thanh toán. Hỗ trợ cấp mã trả phí sau khi giao dịch được xác nhận."
      ),
    },
    {
      question: i18n.t("Giá gói và không giới hạn được hiểu thế nào?"),
      answer: i18n.t(
        "Giá tham khảo đang hiển thị cho 1 năm bằng VND; liên hệ hỗ trợ để xác nhận giá và thời hạn trước khi thanh toán. Gói Page áp dụng cho 1 Page; gói nhiều Page vẫn có giới hạn IP và có thể có hạn mức tin nhắn mỗi tháng. Không giới hạn tin nhắn trong gói không loại bỏ các giới hạn của Facebook hoặc Pancake."
      ),
    },
  ],
}) => {
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

  const toggleQuestion = (questionIndex) => {
    if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null);
    else setActiveQuestionIndex(questionIndex);
  };

  return (
    <Container id="faq">
      <ContentWithPaddingXl>
        <Column>
          <HeaderContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
          </HeaderContent>
          <FAQSContainer>
            {faqs.map((faq, index) => (
              <FAQ
                key={index}
                onClick={() => {
                  toggleQuestion(index);
                }}
                className="group"
              >
                <Question>
                  <QuestionText>{faq.question}</QuestionText>
                  <QuestionToggleIcon
                    variants={{
                      collapsed: { rotate: 0 },
                      open: { rotate: -180 },
                    }}
                    initial="collapsed"
                    animate={
                      activeQuestionIndex === index ? "open" : "collapsed"
                    }
                    transition={{
                      duration: 0.02,
                      ease: [0.04, 0.62, 0.23, 0.98],
                    }}
                  >
                    <ChevronDownIcon />
                  </QuestionToggleIcon>
                </Question>
                <Answer
                  variants={{
                    open: {
                      opacity: 1,
                      height: "auto",
                      marginTop: "16px",
                    },
                    collapsed: {
                      opacity: 0,
                      height: 0,
                      marginTop: "0px",
                    },
                  }}
                  initial="collapsed"
                  animate={activeQuestionIndex === index ? "open" : "collapsed"}
                  transition={{
                    duration: 0.3,
                    ease: [0.04, 0.62, 0.23, 0.98],
                  }}
                >
                  {faq.answer}
                </Answer>
              </FAQ>
            ))}
          </FAQSContainer>
        </Column>
      </ContentWithPaddingXl>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};
